import { useTangerineApi } from 'domains/tangerine/hooks'
import { useContext } from 'react'
import { PatientContext } from 'ui/contexts'
import { useReportTranslation } from 'utilities/i18n'
import { FALLBACK_LOCALE } from 'utilities/i18n/locales'

const useActivityOverview = ({ startDate, endDate }) => {
  const patientContext = useContext(PatientContext) || {}
  const { locale } = useReportTranslation()

  const params = {
    start_date: startDate,
    end_date: endDate,
    patient_id: patientContext.id,
  }

  if (locale && locale !== FALLBACK_LOCALE) {
    params.locale = locale
  }

  const { data, loading, errors } = useTangerineApi({
    path: '/api/v3/activity_overview',
    method: 'GET',
    params,
    axiosOptions: { responseType: 'arraybuffer' },
  })

  return {
    data: data?.data || {},
    isLoading: loading,
    hasError: !!(errors && errors.length),
  }
}

export default useActivityOverview
